
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>照会日</label>
        <datepick v-model="searchForm.model.posted_at_from" :placeholder="'開始日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <datepick v-model="searchForm.model.posted_at_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>店舗ID</label>
        <div class="ui action input">
          <input type="text" v-model="searchForm.model.shop_id" placeholder="店舗ID">
          <button class="ui teal button">Search</button>
        </div>
      </div>
      <div class="field">
        <label>電話番号</label>
        <div class="ui action input">
          <input type="text" v-model="searchForm.model.tel" placeholder="電話番号">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>照会日時</th>
          <th>店舗(ID)</th>
          <th>電話番号</th>
          <th>希望日</th>
          <th>人数</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="form in forms" :key="form.id">
          <td>{{ form.created_at | formatDatetime}}</td>
          <td>{{ form.shop.name }}({{ form.shop.id }})</td>
          <td><a :href="form.related_call_url">{{ form.tel }}</a></td>
          <td>{{ form.event_date | formatDate }}</td>
          <td>{{ form.people_label }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
